import { render, staticRenderFns } from "./PWAInstallPrompt.vue?vue&type=template&id=55d8ee9d&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PWAInstallPrompt.vue?vue&type=style&index=0&id=55d8ee9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8ee9d",
  null
  
)

export default component.exports